import { queryOptions } from "@tanstack/react-query";
import { client, handleClientMethod } from "../client.ts";
import { RECOMMENDATIONS_DEFAULT_LIMIT } from "@/constants/recommendations";

export interface GetRecommendationsParams {
  productIds: string[];
  limit?: number;
}

/**
 * Query options for GET /api/recommendations.
 * Returns a ranked list of recommended product UUIDs for the given cart product IDs.
 */
export const getRecommendations = (params: GetRecommendationsParams) => {
  const { productIds, limit = RECOMMENDATIONS_DEFAULT_LIMIT } = params;
  return queryOptions({
    queryKey: ["recommendations", [...productIds].sort().join(","), limit],
    queryFn: async (): Promise<string[]> => {
      if (productIds.length === 0) return [];
      return await handleClientMethod(
        client.GET("/api/recommendations", {
          params: {
            query: { productIds, limit },
          },
        })
      );
    },
  });
};
